<app-loader></app-loader>
<router-outlet></router-outlet>
<app-notifications [isNotificationBarVisible]="false"></app-notifications>
  <div class="loader-overlay" *ngIf="isLoading">
    <div class="loader"></div>
  </div>